export default {
  /* Dashboard */
  retrieveIncomeSummary: "/dashboard/income-summary/",
  getClientTypeIncome: "/dashboard/client-type-wise-earning/",
  getIncomeChartData: "/dashboard/income-bar-chart/",
  getPaymentChartData: "/dashboard/payment-bar-chart/",
  retrieveTopEarningAccount: "/dashboard/top-earning-account/",
  retrieveTopEarningPlatform: "/dashboard/top-earning-platform/",

  /** Sales Data */
  retrieveSalesFiles: "/sales-files",
  createSalesFile: "/sales-files/",
  getFileColumns: "/sales-files",
  createRawData: "/raw-data/",
  getDateConversion: "/raw-data/date-conversion/",
  getMasterData: "/raw-data/retrieve/",
  editMasterData: "/raw-data",
  deleteMasterData: "/raw-data",
  processMasterData: "/sales-files/raw-data-process/",
  deleteSalesFile: "/raw-data/delete/",
  deleteProcessedFile: "/sales-files",
  downloadSalesFile: "/sales-files",

  /** Currency */
  retrieveCurrencies: "/currencies/",

  /** Platrform */
  retrievePlatforms: "/platforms/",
  createPlatform: "/platforms/",
  editPlatform: "/platforms",

  /** Distributor */
  getDistributors: "/distributors/",
  createDistributor: "/distributors/",
  editDistributor: "/distributors",

  /** User */
  createUser: "/users/",
  editUser: "/users",
  retrieveUsers: "/users",
  getUserSignup: "/signup/",
  updateSignupRequest: "/signup",
  sendSingupRequest: "/signup/",
  retrieveRoles: "/users/roles/",
  login: "/users/token/",
  logout: "/users/logout/",
  refreshToken: "users/token/refresh/",
  userDetails: "/users/detail/",

  /** Tracks */
  retrieveTracks: "/tracks",
  retrieveTracksIncomeSummary: "/tracks/income-summary/",
  retrieveAllTracks: "/tracks/all",
  downloadTracksInCSV: "/tracks/csv/download/",
  createTrack: "/tracks/",
  editTrack: "/tracks/update",
  deleteTrack: "/tracks",

  /** Labels */
  retrieveLabels: "/labels/",
  createLabel: "/labels/",
  editLable: "/labels",
  deleteLabel: "/labels",

  /** Contributors */
  retrieveContributors: "contributors",
  createContributor: "contributors/",
  editContributor: "contributors",
  deleteContributor: "/contributors",

  /** Account */
  retrieveClients: "/clients/",
  retrieveAllClients: "/clients/unpaginate-client/",
  retrieveSingleClient: "/clients",
  createAccount: "/clients/",
  getClientTypes: "/clients/types/",
  getSignupCategory: "/clients/types-public",
  editClientInfo: "/clients/client-info-update",
  editClientFilter: "/clients",
  getIsClientShareExist: "/clients/existing-artist-share/",
  getClientAdjustmentAmount: "/invoice",
  getNoPageClientAdjAmount: "/clients/non-paginated-client-adjustment-amount",
  paymentWithAdjustment: "/clients/payment-attach-with-adjustment-amount/",

  /** Bank Acc Details */
  createBankAccDetails: "/clients/bank-account/",
  editBankAccDetails: "/clients/bank-account",
  retrieveBankAccDetails: "/clients/bank-account",

  /** Income Share */
  retrieveIncomeShare: "/clients/income-share",
  createIncomeShare: "/clients/income-share/",
  editIncomeShare: "/clients/income-share",
  addSpecificIncomeShare: "/tracks/exclusive-artist-share-post/",
  getSpecificIncomeShare: "/tracks/exclusive-artist-share-list/",

  /** Payments */
  retrievePayments: "/payments/",
  createPayment: "/payments/",
  retrievePaymentDetails: "/payments",
  updatePayment: "/payments",

  /** Invoices */
  retrieveInvoices: "/invoice/",
  createInvoice: "/invoice/",
  sendInvoice: "/invoice",
  retrieveInvoiceDetails: "/invoice",
  updateInvoice: "/invoice",

  /* Dues */
  retrieveClientDues: "/dues/",
  retrieveInvoiceDues: "/invoice",
};
